<nav class="app-navbar" [class.minimized]="isNavMinimized()">
    <div class="app-logo" routerLink="/">
        <!--
        <img alt="App Logo" src="/app-logo.svg">
        -->
        <img alt="Generali Group" src="/generali-logo-big.svg" width="70px">
        <div class="app-name layout-vbox" style="align-items: center">
            @if (isNavMinimized()) {
                <div>PFM</div>
            } @else {
                <div>Portfolio</div>
                <div>Management</div>
                <div>Platform</div>
            }
        </div>
    </div>
    <div class="icon-button minimize-nav" style="position: absolute; top: 5px; right: 5px; " (click)="toggleNavMinimized()">
        <i class="far fa-dash"></i>
    </div>

    <div class="menu-divider"></div>

    <!-- Content projection for navigation links -->
    <ng-content></ng-content>
</nav>
